//@ts-nocheck
import React from "react";
import { get } from "lodash";
import { Query } from "react-apollo";
import gql from "graphql-tag";

const tagQuery = gql`
  query tagQuery($tagId: ID!) {
    tag(tagId: $tagId) {
      id
      name
      numStories
    }
  }
`;

interface Props {
  tagId: string;
  children: ({ loading, tag }) => React.ReactElement;
}

class TagQuery extends React.Component<Props> {
  parseData = (data) => ({
    tag: get(data, "tag", {}),
  });

  render() {
    return (
      <Query query={tagQuery} variables={{ tagId: this.props.tagId }}>
        {({ loading, data }) =>
          this.props.children({ loading, ...this.parseData(data) })
        }
      </Query>
    );
  }
}

export default TagQuery;
